import { useEffect, useState } from "react";
import { getLessonWatchMaps } from "../lib/firebase";
import { BUCKET_SEC, clock, heatmap } from "../lib/watchMap";

/** Admin-only: which parts of this lesson's video students really played.
 *  Tall = most viewers watched it; a sudden drop = where people leave or skip. */
export function WatchHeatmap({ lessonId }: { lessonId: string }) {
  const [maps, setMaps] = useState<string[] | null>(null);

  useEffect(() => {
    setMaps(null);
    getLessonWatchMaps(lessonId).then(setMaps).catch(() => setMaps([]));
  }, [lessonId]);

  if (maps === null) return null;
  const bars = heatmap(maps);
  const viewers = maps.filter((m) => m.includes("1")).length;

  return (
    <section className="watch-heatmap" aria-label="ช่วงที่นักเรียนดู">
      <div className="watch-heatmap__head">
        <strong>นักเรียนดูช่วงไหน</strong>
        <span>เห็นเฉพาะแอดมิน · {viewers} คนที่กดดูแล้ว</span>
      </div>
      {viewers === 0 ? (
        <p className="watch-heatmap__empty">ยังไม่มีข้อมูล ข้อมูลจะเริ่มเก็บตั้งแต่นักเรียนดูคลิปหลังอัปเดตนี้</p>
      ) : (
        <>
          <div className="watch-heatmap__bars">
            {bars.map((f, i) => (
              <span
                key={i}
                style={{ height: `${Math.max(4, f * 100)}%`, opacity: 0.35 + f * 0.65 }}
                title={`${clock(i * BUCKET_SEC)}-${clock((i + 1) * BUCKET_SEC)} · ดู ${Math.round(f * 100)}%`}
              />
            ))}
          </div>
          <div className="watch-heatmap__axis">
            <span>0:00</span>
            <span>{clock(bars.length * BUCKET_SEC)}</span>
          </div>
        </>
      )}
    </section>
  );
}
